import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { CloudStoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";

import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { APIStatus } from "@/redux/modules/api/data/cart/cart.module";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorePickerModalStates } from "@/utils/enums";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import { useActionHandlerContext } from "../../context/actionHandler.context";
import { useECommerceContext } from "../../context/eCommerce.context";
import { useStorePickerModalContext } from "../../context/storePickerModal.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";

const StorePickerSelectComponent = () => {
    const { t } = useGranite();
    const {
        storePickerType,
        storePickerModalState,
        setStorePickerModalState,
        storeCode
    } = useStorePickerModalContext();
    const { isEcommerceReady, infoLink, product } = useECommerceContext();
    const { isBoxArticle } = useECommerceProduct();
    const { deliveryType } = useProductDetail();
    const { open: openModal } = useModalRouter(
        ModalType.AddToCart,
        product.sku
    );
    const { onAddToCart } = useActionHandlerContext();
    const isOpen = storePickerModalState !== StorePickerModalStates.Closed;

    return (
        <>
            {isEcommerceReady &&
                storePickerType === StorePickerType.SELECT &&
                isOpen && (
                    <StorePickerModal
                        isOpen={isOpen}
                        type={StorePickerType.SELECT}
                        displayStockLevel={!isBoxArticle}
                        infoLink={infoLink}
                        storeCode={storeCode}
                        fixedFeatures={
                            deliveryType === DeliveryType.ClickAndCollect
                                ? [
                                      StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE
                                  ]
                                : []
                        }
                        onClose={() =>
                            setStorePickerModalState(
                                StorePickerModalStates.Closed
                            )
                        }
                        submitButtonText={
                            storePickerModalState ===
                            StorePickerModalStates.AddToCart
                                ? t(
                                      "general.storepicker.button.confirmStoreAndOrder"
                                  )
                                : ""
                        }
                        filterStoreType={CloudStoreType.WalkIn}
                        onSubmit={(shop, onClose) => {
                            if (
                                storePickerModalState !==
                                StorePickerModalStates.AddToCart
                            ) {
                                onClose?.();
                                return;
                            }

                            onAddToCart(shop.code).then((action) => {
                                if (action.type === APIStatus.SUCCESS) {
                                    onClose?.();
                                    openModal(false);
                                } else if (action.type === APIStatus.FAILURE) {
                                    broadcastMessage({
                                        id: "pdp-error",
                                        text: action.payload.message,
                                        status: "danger",
                                        dismissible: true
                                    });
                                }
                            });
                        }}
                    />
                )}
        </>
    );
};

export { StorePickerSelectComponent };
